import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  status: 'idle',
  error: null,
  courseId: null,
  elementId: null,
  resolvedElementId: null,
  eventName: null,
  matchedElementId: null,
  checkedAt: null,
  startedAt: null,
};

const slice = createSlice({
  name: 'proctor',
  initialState,
  reducers: {
    proctorCheckRequested(state, action) {
      state.status = 'checking';
      state.error = null;
      state.courseId = action.payload.courseId;
      state.elementId = action.payload.elementId;
      state.resolvedElementId = action.payload.resolvedElementId ?? null;
      state.eventName = null;
      state.matchedElementId = null;
      state.checkedAt = null;
      state.startedAt = null;
    },
    proctorNotRequired(state, action) {
      state.status = 'not-required';
      state.error = null;
      state.courseId = action.payload?.courseId ?? state.courseId;
      state.elementId = action.payload?.elementId ?? state.elementId;
      state.resolvedElementId = action.payload?.resolvedElementId ?? state.resolvedElementId;
      state.eventName = null;
      state.matchedElementId = null;
      state.checkedAt = Date.now();
    },
    proctorRequired(state, action) {
      state.status = 'required';
      state.error = null;
      state.courseId = action.payload.courseId;
      state.elementId = action.payload.elementId;
      state.resolvedElementId = action.payload.resolvedElementId ?? null;
      state.eventName = action.payload.eventName;
      state.matchedElementId = action.payload.matchedElementId ?? null;
      state.checkedAt = Date.now();
    },
    proctorBlocked(state, action) {
      state.status = 'blocked';
      state.error = action.payload ?? 'This test cannot start on this device.';
    },
    proctorStarting(state) {
      state.status = 'starting';
      state.error = null;
    },
    proctorStarted(state) {
      state.status = 'active';
      state.error = null;
      state.startedAt = Date.now();
    },
    proctorFailed(state, action) {
      state.status = 'failed';
      state.error = action.payload ?? 'Could not start remote proctoring.';
    },
    proctorStopped() {
      return initialState;
    },
    proctorCleared() {
      return initialState;
    },
  },
});

export const {
  proctorCheckRequested,
  proctorNotRequired,
  proctorRequired,
  proctorBlocked,
  proctorStarting,
  proctorStarted,
  proctorFailed,
  proctorStopped,
  proctorCleared,
} = slice.actions;

export const proctorReducer = slice.reducer;
